import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@/lib/queryKeys';
import { STATIC_DATA_CONFIG } from '@/lib/queryClient';

/**
 * Skill type definition
 * TODO: Move to shared types file if needed elsewhere
 */
export interface Skill {
  id: number;
  name: string;
}

/**
 * Optimized hook for fetching skills with aggressive caching
 * - 24h staleTime ensures instant load on subsequent visits
 * - 7d gcTime keeps data in memory even when component unmounts
 * - No refetch on mount/focus/reconnect - treated as static data
 * - keepPreviousData ensures instant UI render while revalidating
 */
export function useSkills() {
  return useQuery<Skill[]>({
    queryKey: queryKeys.skills.list(),
    queryFn: async () => {
      const response = await fetch('/api/skills', { credentials: 'include' });
      if (!response.ok) {
        throw new Error('Failed to fetch skills');
      }
      return response.json();
    },
    ...STATIC_DATA_CONFIG,
    // Keep previous data for instant render during background revalidation
    placeholderData: (previousData) => previousData,
  });
}
